import { Chip, ChipProps } from '@mui/material'
import { FC } from 'react'

/**
 * @designSystem
 */
export type C1ChipProps = Omit<ChipProps, 'label' | 'size'> & {
    /** Chip content. Required. */
    label: NonNullable<React.ReactNode>
    /** Chip size. extraSmall is C1-specific (10px font, 16px height). */
    size?: 'small' | 'medium' | 'extraSmall'
}

export const extraSmallChipSx = { fontSize: '10px', height: '16px', ml: '6px' }

/**
 * Compact element for tags, filters, or small pieces of information.
 *
 * @designSystem
 * @category c1ui
 * @relatedComponents C1Button, DisplayNameDetails
 */
export const C1Chip: FC<C1ChipProps> = (props) => {
    const { size, ...rest } = props
    const chipSize = size === 'extraSmall' ? 'small' : size
    const chipSx = size === 'extraSmall' ? extraSmallChipSx : rest.sx

    return <Chip {...rest} size={chipSize} sx={chipSx} />
}
